import React from 'react'
import { ButtonClose } from "./styled"

export const CloseButton = props => {
  return <ButtonClose {...props}>&times;</ButtonClose>
}
